import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Old per-workflow editor URL.  The graph editor now lives inline in
 * Team Settings → Workflow; redirect there with the workflow pre-selected.
 */
export const Route = createFileRoute('/workflows/$workflowId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/settings',
      search: { tab: 'workflow', workflow: params.workflowId },
    });
  },
});
